import { IntlShape } from 'react-intl';

export const defaultLocale = 'en';
export const supportedLocales = ['en'] as const;

export type SupportedLocale = (typeof supportedLocales)[number];

// Type-safe message keys
export type MessageKey = keyof typeof import('./messages/en.json');

// Load messages for a specific locale
export async function loadMessages(locale: SupportedLocale) {
  switch (locale) {
    case 'en':
      return (await import('./messages/en.json')).default;
    default:
      return (await import('./messages/en.json')).default;
  }
}

// Get the user's preferred locale
export function getUserLocale(): SupportedLocale {
  const browserLocale = navigator.language.split('-')[0];
  return supportedLocales.includes(browserLocale as SupportedLocale)
    ? (browserLocale as SupportedLocale)
    : defaultLocale;
}

// Format a message with ICU syntax support
export function formatMessage(
  intl: IntlShape,
  id: string,
  values?: Record<string, any>,
) {
  return intl.formatMessage({ id }, values);
}
